import { Box, Table as ChakraTable, TableCaption } from "@biblioteksentralen/react";
import { Table } from "@libry-content/types";
import { PortableTextTypeComponentProps } from "@portabletext/react";
import { PropsWithChildren } from "react";

type Props = PropsWithChildren<PortableTextTypeComponentProps<Table>>;

const numColumnCellPaddings: Record<number, string> = {
  1: "2rem",
  2: "2rem",
  3: "1.5rem",
  4: "1.25rem",
};

export function TextTableSerializer(props: Props) {
  const { columnHeaders, rows, showRowHeaders, showColumnHeaders, caption } = props.value ?? {};

  const totalNumberOfColumns = (columnHeaders?.cells?.length ?? 0) + (showRowHeaders ? 1 : 0);
  return (
    <Box overflowX="auto" marginY="3rem" maxW="40rem">
      <ChakraTable.Root
        size={{ base: "sm", sm: "md" }}
        css={{
          "& th": {
            color: "inherit",
            textTransform: "none",
          },
          "& td,th": {
            whiteSpace: "nowrap",
            padding: `0.5rem ${numColumnCellPaddings[totalNumberOfColumns] ?? ".5rem"}`,
            textAlign: "start",
            borderColor: "gray.200",
          },
        }}
        maxWidth={`${totalNumberOfColumns < 5 ? "max-content" : undefined}`}
      >
        {caption && (
          <TableCaption fontStyle="italic" opacity={0.8} marginTop={2}>
            {caption}
          </TableCaption>
        )}
        {showColumnHeaders && (
          <ChakraTable.Header>
            <ChakraTable.Row>
              {showRowHeaders && <ChakraTable.ColumnHeader>{columnHeaders?.rowHeader}</ChakraTable.ColumnHeader>}
              {columnHeaders?.cells?.map((cell, i) => (
                <ChakraTable.ColumnHeader key={i}>{cell}</ChakraTable.ColumnHeader>
              ))}
            </ChakraTable.Row>
          </ChakraTable.Header>
        )}
        <ChakraTable.Body>
          {rows?.map((row) => (
            <ChakraTable.Row key={row._key}>
              {showRowHeaders && <ChakraTable.ColumnHeader>{row.rowHeader}</ChakraTable.ColumnHeader>}
              {row.cells?.map((cell, i) => (
                <ChakraTable.Cell key={i}>{cell}</ChakraTable.Cell>
              ))}
            </ChakraTable.Row>
          ))}
        </ChakraTable.Body>
      </ChakraTable.Root>
    </Box>
  );
}
